export default function isCustomerLoaded(context, customerId) {
  return context.stores.customers.has({ id: customerId });
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/lib/is_customer_loaded.js